import { T } from "../../constants/theme";
import cropImage from "../../assets/illustrations/product-crate.jpg";
import seedImage from "../../assets/illustrations/product-seedpack.webp";
import compostImage from "../../assets/illustrations/advice-composting.jpg";
import toolsImage from "../../assets/illustrations/product-tools.jfif";
import plantImage from "../../assets/illustrations/product-plant.jpg";
import calendarImage from "../../assets/illustrations/advice-calendar.webp";

export default function AdvicePage() {
  const articles = [
    {
      title: "Building Healthy Soil From the Ground Up",
      cat: "Soil & Compost",
      image: compostImage,
      date: "May 2026",
      excerpt:
        "What actually makes soil 'good,' and simple habits that build it season after season.",
    },
    {
      title: "A Beginner's Planting Calendar",
      cat: "Seeds & Plants",
      image: calendarImage,
      date: "May 2026",
      excerpt:
        "What to sow and when, month by month, so nothing goes in the ground too early or too late.",
    },
    {
      title: "Choosing the Right Crop for Your Plot",
      cat: "Fresh Produce",
      image: cropImage,
      date: "Apr 2026",
      excerpt:
        "Matching what you grow to your soil, sun, and space — before you buy a single seed.",
    },
    {
      title: "Starting Seeds Indoors: A Practical Guide",
      cat: "Seeds & Plants",
      image: seedImage,
      date: "Apr 2026",
      excerpt:
        "Get a head start on the season with a setup that doesn't need a greenhouse.",
    },
    {
      title: "The Tools Every Grower Actually Needs",
      cat: "Garden Tools",
      image: toolsImage,
      date: "May 2026",
      excerpt:
        "Skip the gadgets — here's the short list of tools that earn a place in the shed.",
    },
    {
      title: "Container Gardening in Small Spaces",
      cat: "Seeds & Plants",
      image: plantImage,
      date: "May 2026",
      excerpt:
        "No plot, no problem. Growing herbs and vegetables well in pots and raised beds.",
    },
  ];

  return (
    <section
      style={{
        background: T.paper,
        padding: "90px 0",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          maxWidth: 1400,
          margin: "0 auto",
          padding: "0 32px",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            textAlign: "center",
            marginBottom: 70,
          }}
        >
          <span
            style={{
              color: T.gold,
              textTransform: "uppercase",
              letterSpacing: ".15em",
              fontWeight: 700,
              fontSize: 12,
            }}
          >
            Growing Guide
          </span>

          <h1
            style={{
              fontFamily: "'Georgia', serif",
              fontSize: 48,
              color: T.ink,
              margin: "12px 0",
              lineHeight: 1.1,
            }}
          >
            Growing Advice & Guides
          </h1>

          <p
            style={{
              color: T.muted,
              fontSize: 16,
              maxWidth: 700,
              margin: "0 auto",
              lineHeight: 1.7,
            }}
          >
            Practical growing advice, seasonal planting guides, and tips
            curated by our team to help your garden or farm thrive.
          </p>

          <div
            style={{
              width: 70,
              height: 2,
              background: T.gold,
              margin: "24px auto 0",
            }}
          />
        </div>

        {/* ARTICLES GRID */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(320px, 1fr))",
            gap: 30,
          }}
        >
          {articles.map((a, i) => (
            <div
              key={i}
              style={{
                background: "#fff",
                borderRadius: 24,
                overflow: "hidden",
                cursor: "pointer",
                boxShadow: "0 10px 30px rgba(0,0,0,.06)",
                transition: "all .35s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform =
                  "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 50px rgba(0,0,0,.06)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform =
                  "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 10px 30px rgba(0,0,0,.06)";
              }}
            >
              {/* ARTICLE IMAGE */}
              <div
                style={{
                  height: 260,
                  overflow: "hidden",
                }}
              >
                <img
                  src={a.image}
                  alt={a.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform .5s ease",
                  }}
                />
              </div>

              {/* CONTENT */}
              <div
                style={{
                  padding: 28,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 14,
                    fontSize: 12,
                    color: T.gold,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: ".08em",
                  }}
                >
                  <span>{a.cat}</span>
                  <span>{a.date}</span>
                </div>

                <h3
                  style={{
                    fontFamily: "'Georgia', serif",
                    fontSize: 28,
                    lineHeight: 1.3,
                    color: T.ink,
                    margin: 0,
                    marginBottom: 18,
                  }}
                >
                  {a.title}
                </h3>

                <p
                  style={{
                    color: T.muted,
                    fontSize: 15,
                    lineHeight: 1.7,
                    marginBottom: 24,
                  }}
                >
                  {a.excerpt}
                </p>

                <div
                  style={{
                    color: T.ink,
                    fontWeight: 700,
                    fontSize: 14,
                    letterSpacing: ".05em",
                    textTransform: "uppercase",
                  }}
                >
                  Read Article →
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );

// }
// function LookbookPage({ setPage }) {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [drawerLook, setDrawerLook] = useState(null);

//   const [lookProducts, setLookProducts] = useState({});
//   const [loading, setLoading] = useState(false);

//   const toast = useContext(ToastContext);
//   const { addItem } = useContext(CartContext) || {};

//   // -------------------------------
//   // FETCH PRODUCTS BY CATEGORY SLUG
//   // -------------------------------
//   const fetchByCategory = async (slug) => {
//     try {
//       const res = await fetch(`/api/products?category=${slug}`);
//       const json = await res.json();
//       return json.data || [];
//     } catch (err) {
//       console.error("Fetch failed", err);
//       return [];
//     }
//   };

//   // -------------------------------
//   // LOAD ALL LOOKBOOKS DATA
//   // -------------------------------
//   useEffect(() => {
//     const load = async () => {
//       setLoading(true);

//       const streetwear = await fetchByCategory("streetwear");
//       const oversized = await fetchByCategory("oversized");

//       setLookProducts({
//         streetwear,
//         oversized,
//       });

//       setLoading(false);
//     };

//     load();
//   }, []);

//   // -------------------------------
//   // LOOKBOOK DATA (NOW CLEAN)
//   // -------------------------------
//   const LOOKBOOKS = [
//     {
//       id: 1,
//       title: "Streetwear Essentials",
//       subtitle: "Urban Layers 2026",
//       slug: "streetwear",
//       image:
//         "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=1800",
//       products: lookProducts.streetwear || [],
//     },
//     {
//       id: 2,
//       title: "Oversized Fits",
//       subtitle: "Relaxed Comfort",
//       slug: "oversized",
//       image:
//         "https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=1800",
//       products: lookProducts.oversized || [],
//     },
//   ];

//   // -------------------------------
//   // OPEN DRAWER
//   // -------------------------------
//   const openLook = (look) => {
//     setDrawerLook({
//       ...look,
//       products: look.products || [],
//     });
//     setDrawerOpen(true);
//   };

//   // -------------------------------
//   // REMOVE ITEM FROM LOOK
//   // -------------------------------
//   const removeItem = (id) => {
//     setDrawerLook((prev) => ({
//       ...prev,
//       products: prev.products.filter((p) => p.id !== id),
//     }));
//   };

//   // -------------------------------
//   // ADD ENTIRE LOOK TO CART
//   // -------------------------------
//   const addLookToCart = () => {
//     drawerLook?.products?.forEach((p) => addItem?.(p.id, 1));

//     toast?.("Entire outfit added to cart");
//     setDrawerOpen(false);
//     setPage?.("cart");
//   };

//   return (
//     <div
//       style={{
//         height: "100vh",
//         overflowY: "auto",
//         scrollSnapType: "y mandatory",
//         background: "#111",
//       }}
//     >
//       {/* LOADING STATE */}
//       {loading && (
//         <div style={{ color: "#fff", padding: 20 }}>Loading looks...</div>
//       )}

//       {/* LOOK SECTIONS */}
//       {LOOKBOOKS.map((look) => (
//         <LookbookSection
//           key={look.id}
//           look={look}
//           onShop={() => openLook(look)}
//         />
//       ))}

//       {/* FLOAT BUTTON */}
//       <button
//         onClick={() => openLook(LOOKBOOKS[0])}
//         style={{
//           position: "fixed",
//           right: 30,
//           bottom: 30,
//           background: "#fff",
//           color: "#111",
//           border: "none",
//           borderRadius: 999,
//           padding: "18px 30px",
//           cursor: "pointer",
//           fontWeight: 700,
//         }}
//       >
//         SHOP THIS LOOK
//       </button>

//       {/* DRAWER */}
//       {drawerOpen && (
//         <>
//           <div
//             onClick={() => setDrawerOpen(false)}
//             style={{
//               position: "fixed",
//               inset: 0,
//               background: "rgba(0,0,0,.4)",
//               zIndex: 900,
//             }}
//           />

//           <div
//             style={{
//               position: "fixed",
//               top: 0,
//               right: 0,
//               bottom: 0,
//               width: 420,
//               background: "#fff",
//               zIndex: 901,
//               display: "flex",
//               flexDirection: "column",
//             }}
//           >
//             {/* HEADER */}
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 padding: 10,
//                 borderBottom: "1px solid #eee",
//               }}
//             >
//               <h2>Shop The Look</h2>
//               <button onClick={() => setDrawerOpen(false)}>✕</button>
//             </div>

//             {/* PRODUCTS */}
//             <div style={{ flex: 1, overflowY: "auto", padding: 20 }}>
//               {drawerLook?.products?.length === 0 && (
//                 <p>No products found for this look.</p>
//               )}

//               {drawerLook?.products?.map((p) => (
//                 <div
//                   key={p.id}
//                   style={{
//                     display: "flex",
//                     gap: 12,
//                     marginBottom: 16,
//                     borderBottom: "1px solid #eee",
//                     paddingBottom: 12,
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: 60,
//                       height: 60,
//                       background: "#f3f3f3",
//                       borderRadius: 8,
//                     }}
//                   />

//                   <div style={{ flex: 1 }}>
//                     <p style={{ margin: 0, fontWeight: 600 }}>{p.name}</p>
//                     <p style={{ margin: "4px 0", fontWeight: 700 }}>
//                       £{Number(p.sale_price || p.price).toFixed(2)}
//                     </p>

//                     <button
//                       onClick={() => removeItem(p.id)}
//                       style={{
//                         border: "none",
//                         background: "none",
//                         color: "red",
//                         fontSize: 12,
//                         cursor: "pointer",
//                       }}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {/* FOOTER */}
//             <div style={{ padding: 20, borderTop: "1px solid #eee" }}>
//               <button
//                 onClick={addLookToCart}
//                 style={{
//                   width: "100%",
//                   background: "#111",
//                   color: "#fff",
//                   border: "none",
//                   padding: 14,
//                   fontWeight: 700,
//                   borderRadius: 10,
//                 }}
//               >
//                 Add Entire Outfit To Cart
//               </button>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }function LookbookSection({ look, onShop }) {
//   const ref = useRef();
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const obs = new IntersectionObserver(([entry]) => {
//       if (entry.isIntersecting) setVisible(true);
//     }, { threshold: 0.5 });

//     if (ref.current) obs.observe(ref.current);
//     return () => obs.disconnect();
//   }, []);

//   return (
//     <section
//       ref={ref}
//       style={{
//         height: "100vh",
//         position: "relative",
//         scrollSnapAlign: "start",
//       }}
//     >
//       <img
//         src={look.image}
//         style={{ width: "100%", height: "100%", objectFit: "cover" }}
//       />

//       <div
//         style={{
//           position: "absolute",
//           inset: 0,
//           background: "linear-gradient(to top, rgba(0,0,0,.8), transparent)",
//         }}
//       />

//       <div
//         style={{
//           position: "absolute",
//           left: 80,
//           bottom: 80,
//           color: "#fff",
//           opacity: visible ? 1 : 0,
//           transform: visible ? "translateY(0)" : "translateY(40px)",
//           transition: ".6s ease",
//         }}
//       >
//         <h1>{look.title}</h1>
//         <p>{look.subtitle}</p>

//         <button
//           onClick={onShop}
//           style={{
//             padding: "14px 24px",
//             borderRadius: 12,
//             border: "none",
//             fontWeight: 700,
//           }}
//         >
//           Shop The Look
//         </button>
//       </div>
//     </section>
//   );
}
